const auth = {
  login: {
    title: 'Welcome',
    subtitle: 'Sign in to your account',
    username: 'Email',
    password: 'Password',
    sign_in: 'Sign In',
    remember_me: 'Remember me',
    forgot_password: 'Forgot your password?',
    error: 'Incorrect username or password',
    loading: 'Signing in...',
  },
  logout: {
    title: 'Sign Out',
    message: 'Are you sure you want to sign out?',
    confirm: 'Sign out',
    cancel: 'Cancel',
  },
  errors: {
    invalid_credentials: 'Invalid credentials',
    session_expired: 'Your session has expired',
    unauthorized: 'You do not have permission to access this resource',
    forbidden: 'Access denied',
    network_error: 'Connection error',
  },
  password: {
    change_title: 'Change Password',
    current: 'Current password',
    new_password: 'New password',
    confirm: 'Confirm new password',
    requirements: {
      title: 'Password must have:',
      minLength: 'At least 8 characters',
      uppercase: 'An uppercase letter',
      lowercase: 'A lowercase letter',
      number: 'A number',
      special: 'A special character (!@#$%^&*)',
    },
    errors: {
      mismatch: 'Passwords do not match',
      weak: 'Password is too weak',
      same: 'New password must be different from the current one',
    },
    success: 'Password updated successfully',
  },
  roles: {
    Admin: 'Administrator',
    User: 'User',
    ReadOnly: 'Read Only',
  },
  session_expiry: {
    title: 'Session about to expire',
    message: 'Your session will expire soon. Do you want to extend it?',
    extend: 'Extend session',
  },
};

export default auth;
